import React from "react";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-ff-bg pt-24 md:pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <p className="label text-ff-accent mb-4">LEGAL</p>
        <h1 className="font-serif text-display text-ff-text mb-8">Privacy Policy</h1>
        <p className="text-ff-text-muted text-sm mb-12">Last updated: February 2026</p>

        <div className="prose-legal space-y-8 text-ff-text-muted text-sm leading-relaxed">

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">1. Introduction</h2>
            <p>Freddy Fiction, operated by Freddy Media ("we," "us," or "our"), respects your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">2. Information We Collect</h2>
            <p><strong className="text-ff-text">Information you provide:</strong></p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Email address (when subscribing or creating an account)</li>
              <li>Payment information (processed securely through Stripe; we do not store card details)</li>
              <li>Series subscription preferences</li>
            </ul>
            <p className="mt-3"><strong className="text-ff-text">Information collected automatically:</strong></p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Device and browser information</li>
              <li>IP address</li>
              <li>Pages visited and reading activity</li>
              <li>Referring website or source</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>To deliver story content and manage your subscriptions</li>
              <li>To send scheduled chapter emails for series you have subscribed to</li>
              <li>To process payments for paid subscription tiers</li>
              <li>To improve our website, content, and services</li>
              <li>To communicate important updates about the service</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">4. Email Communications</h2>
            <p>When you subscribe, you consent to receive chapter emails for the series you select. We use Mailgun to deliver these emails. You can unsubscribe from any series at any time by contacting us or using the unsubscribe link in any email.</p>
            <p className="mt-2">We will never sell your email address to third parties or send unsolicited promotional emails unrelated to your subscriptions.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">5. Payment Processing</h2>
            <p>Paid subscriptions are processed through Stripe. When you make a payment, your card information is sent directly to Stripe's secure servers. We do not store, access, or process your full credit card number. Please refer to <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-ff-accent hover:underline">Stripe's Privacy Policy</a> for information on how they handle your payment data.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">6. Third-Party Services</h2>
            <p>We use the following third-party services:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong className="text-ff-text">Stripe:</strong> Payment processing</li>
              <li><strong className="text-ff-text">Mailgun:</strong> Email delivery for chapter subscriptions</li>
              <li><strong className="text-ff-text">MongoDB:</strong> Secure data storage</li>
            </ul>
            <p className="mt-2">Each service has its own privacy policy governing their handling of your data.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">7. Data Retention</h2>
            <p>We retain your personal information for as long as your account is active or as needed to provide you services. If you request deletion of your account, we will remove your personal data within 30 days, except where retention is required by law.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">8. Your Rights</h2>
            <p>Depending on your jurisdiction, you may have the right to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt out of email communications</li>
              <li>Export your data in a portable format</li>
            </ul>
            <p className="mt-2">To exercise any of these rights, please contact us at <a href="mailto:privacy@freddyfiction.com" className="text-ff-accent hover:underline">privacy@freddyfiction.com</a>.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">9. Data Security</h2>
            <p>We implement industry-standard security measures to protect your personal information, including encrypted data transmission (HTTPS), secure database access controls, and regular security reviews. However, no method of internet transmission is 100% secure.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">10. Children's Privacy</h2>
            <p>Our service is not directed to individuals under 13 years of age. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">11. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of material changes by email or by posting a notice on the Site. Your continued use of the Site after changes are posted constitutes your acceptance of the revised Policy.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">12. Contact Us</h2>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:privacy@freddyfiction.com" className="text-ff-accent hover:underline">privacy@freddyfiction.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
